module.exports = __webpack_public_path__ + "static/media/Strategic Pricing.df27e8d2.svg";